const doubleClickSolution = () => {
    $("#complete-order-link").css("pointer-events", "auto").removeAttr('disabled');
    $(".oneClickOnly").not('[data-toggle="modal"]').on('click touch', function(e) {
        var button = $(this);
        button.css('pointer-events', 'none');
        button.attr('disabled', 'disabled');
        setTimeout(function(){
            if ($('.has-error').length > 0) {
                setTimeout(function() {
                    button.removeAttr('disabled');
                    button.css('pointer-events', '');
                }, 3000);
            } else {
                $('#complete-order-link, #complete-order-link-top').addClass("disabled");
                $('#complete-order-link, #complete-order-link-top').css('opacity','.65');
                    // button.removeAttr('disabled');
                    // button.css('pointer-events', '');
            }
        }, 300);
    });
};

const IBMCookieSolution = () => {
    $('body').on('click', '.prevent-double-click-hack-for-ibm-cookie-problem', function(e) {
        var $this = $(this);
        if ($this.hasClass('clicked')) return;
        else {
            $this.addClass('clicked');
            if ($(this).attr('href') === undefined) {
                var button = $(this);
                button.attr('disabled', 'disabled');
                setTimeout(function() {
                    button.removeAttr('disabled');
                    $this.removeClass('clicked');
                }, 3000);
            } else if ($(this).attr('onclick') !== undefined) {
                var onclickRef = $(this).attr('onclick');
                $(this).attr('onclick', 'javascript:void(0)');
                setTimeout(function() {
                    $(this).attr('onclick', onclickRef).click();
                    $this.removeClass('clicked');
                }, 3000);
            } else if ($(this).data('toggle') === 'modal') {
                setTimeout(function() {
                    $(this).click();
                    $this.removeClass('clicked');
                }, 3000);
            } else {
                var link = $(this).attr('href');
                $this.bind('click.shopBind', false);
                setTimeout(function() {
                    $this.attr("href", link);
                    $this.unbind('click.shopBind');
                }, 3000);
            };
        };
    });
};

export const preventDoubleClick = () => {
    doubleClickSolution();
    IBMCookieSolution();
}
